import { render, staticRenderFns } from "./ErrorState.vue?vue&type=template&id=72cd340f&"
import script from "./ErrorState.vue?vue&type=script&lang=js&"
export * from "./ErrorState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports